<template>
  <header>
    <div class="site-topbar">
      <div class="container">
        <div class="topbar-nav">
          <div class="logo-box" @click="handleSelect('/home')">
            <img src="@/assets/img/logo.png" alt="logo" />
          </div>
          <div :class="['menu-item', activePath == item.path ? 'active-menu-item' : '']" v-for="item in menuData" :key="item.meta.title" @click="handleSelect(item.path)">
            {{ item.meta.title }}
          </div>
          <div class="contact-content">
            <span>客服热线：9:00-17:00</span>
            <span>0731-86407968</span>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      activePath: "",
      menuData: [],
    };
  },
  mounted() {
    this.activePath = this.$route.path;
    this.getTenantService();
  },
  computed: {},
  components: {},
  watch: {
    $route(to, from) {
      this.activePath = to.path;
    },
  },
  methods: {
    handleSelect(val) {
      this.activePath = val;
      this.$router.push(val);
    },
    getTenantService() {
      let menuData = this.$_.cloneDeep(this.$router.options.routes.filter((v) => !v.hidden));
      this.menuData = menuData;
    },
  },
};
</script>

<style lang="scss" scoped>
.site-topbar {
  width: 100%;
  background: #f6f7f9;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  .topbar-nav {
    width: 100%;
    height: 80px;
    display: flex;
    align-items: flex-start;
    .menu-item {
      height: 74px;
      line-height: 80px;
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      margin-right: 60px;
      cursor: pointer;
      &.menu-item:last-child {
        margin-right: 0;
      }
      &.active-menu-item {
        border-bottom: 6px solid #fb463f;
      }
    }
    .logo-box {
      margin-right: 168px;
      cursor: pointer;

      img {
        width: 224px;
        height: 80px;
      }
    }
    .contact-content {
      height: 80px;
      margin-left: auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      span {
        font-weight: bold;
        text-align: right;
        &:nth-child(1) {
          font-size: 16px;
          color: #333333;
        }
        &:nth-child(2) {
          font-size: 20px;
          color: #fb463f;
          margin-top: 8px;
        }
      }
    }
  }
}
</style>
